<template>
    <div class="page">
        <toolbar-system :sideIcon="system.sideIcon"></toolbar-system>
        <progress-system :isLoad="system.progress"></progress-system>
        <v-container>
            <v-layout>
                <v-flex xs12>
                    <v-card v-if="usuario != null">
                        <v-card-text>
                            <v-layout>
                                <v-flex xs2>
                                    <v-avatar size="120">
                                        <v-img :src="'http://sis.al.rn.dti.systems/sis/cliente/fotos/' + usuario.IdPessoaFisica + '.jpg'"></v-img>
                                    </v-avatar>
                                </v-flex>
                                <v-flex xs10>
                                    <h1>{{usuario.Nome}}</h1>
                                    <div>
                                        <strong>Matrícula:</strong> {{usuario.IdPessoaFisica}} <br>
                                        <strong>Nascimento:</strong> {{$moment(usuario.DataNascimento).format('LL')}} <br>
                                        <strong>E-mail:</strong> {{usuario.Email}} <br>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import ToolbarSystem from '../components/ToolbarSystem'
import ProgressSystem from '../components/ProgressSystem'
export default{
    components:{
        ToolbarSystem,
        ProgressSystem
    },
    data(){
        return{
            system:{
                sideIcon: true,
                progress: true
            },
            usuario: null
        }
    },
    methods:{
        getUser () {
            this.axios.get('user').then(res => {
                this.usuario = res.data
            }).finally(() => {
                this.system.progress = false
            })
        }
    },
    mounted(){
        this.getUser()
    }
}
</script>
<style scoped>
    .avatarPerfil{
        margin: auto auto !important;
    }
</style>